import { __awaiter, __extends, __generator } from "tslib";
import { BaseApi } from '../BaseApi';
import { query as getSubscriptionQuery } from '../../graphql/getSubscription.graphql';
import { GraphQLOperations } from '../constants';
var SubscriptionApi = /** @class */ (function (_super) {
    __extends(SubscriptionApi, _super);
    function SubscriptionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionApi.prototype.fetchSubscription = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch({
                            variables: variables,
                            query: getSubscriptionQuery,
                            operationName: GraphQLOperations.GetSubscription,
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.subscription];
                }
            });
        });
    };
    return SubscriptionApi;
}(BaseApi));
export { SubscriptionApi };
//# sourceMappingURL=SubscriptionApi.js.map